import type React from 'react';

/**
 * Get the anchor element from a mouse event.
 * @param event The mouse event.
 * @returns The anchor element if found.
 */
function getAnchorFromEvent(event: React.MouseEvent): HTMLAnchorElement | null {
    const target = event.target;
    if (!(target instanceof Element)) {
        return null;
    }
    return target.closest('a');
}

/**
 * Get the href from an anchor element from a mouse event.
 * @param event The mouse event.
 * @returns The href if found.
 */
export function getAnchorHrefFromEvent(event: React.MouseEvent): string | null {
    const anchor = getAnchorFromEvent(event);
    if (!anchor) {
        return null;
    }
    return anchor.getAttribute('href') || null;
}
